import React from 'react';
import Layout from '../../components/UI/Layout/Layout'
import ContainerPriceList from '../../components/Entity/ContainerPrice/List/List';
  
const ContainerPricesPage = () => {
  return <Layout fullwidth={0}>
   
      <ContainerPriceList></ContainerPriceList>
     
  </Layout>;
}

export default ContainerPricesPage;
